import React, { useState, useEffect } from 'react';

function ClickRippleEffect() {
  const [ripples, setRipples] = useState([]);
  
  const addRipple = (event) => {
    const { clientX, clientY } = event;
    const ripple = {
      x: clientX,
      y: clientY,
      id: new Date().getTime(),
    };
    setRipples([...ripples, ripple]);

    // 移除旧的涟漪效果
    setTimeout(() => {
      setRipples((prevRipples) => prevRipples.slice(1));
    }, 1000);
  };

  useEffect(() => {
    // 添加全局点击事件监听器
    window.addEventListener('click', addRipple);

    return () => {
      // 移除全局点击事件监听器
      window.removeEventListener('click', addRipple);
    };
  }, []);

  return (
    <div className="click-ripple-container">
      {ripples.map((ripple) => (
        <div
          key={ripple.id}
          className="ripple"
          style={{ left: ripple.x, top: ripple.y }}
        ></div>
      ))}
    </div>
  );
}

export default ClickRippleEffect;
